<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">智慧康养解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          伴随中国城乡居民在全生命周期健康管理、养老产业服务（含医养结合）领域日益增长的全面化、贯通化、个性化需要的发展过程，在中国养老领域的复杂社会背景下，橡诺科技始终致力于在健康养老领域的深耕，多年来逐步形成了：<br>
          以构建多场景的城市康养云服务平台，提供涵盖行业内多维度洞察分析的康养大数据服务为战略定位<br>
          以区域和二、三线城市政府为重点服务对象，大力协助政府民政主管部门、卫生部门实现产业扶植和行业监管职能<br>
          以政府倡导的健康养老和医疗改革事业发展规划为指引<br>
          以尊重养老产业的特殊性为前提<br>
          以广泛结盟、扶植基层乡镇社区、居家物联网设备和运营服务提供商为平台业务生态繁荣和商业成功的保障<br>
          以切实解决社区乡镇居民，尤其是60岁以上老人的痛点为价值体现<br>
          的一整套发展策略，并基于“互联网＋健康养老”的思路不断探索创新服务模式、培育发展新业态，为助力中国的智慧康养产业不断升级、到2020年实现生命康养大数据产业体系努力贡献一份力量。
          <div class="img"><img src="@/assets/img/solution/12/1.png"></div>
        </div>
        <div class="title-sub">智慧养老解决方案（含医养结合）</div>
        <div class="text">
          基于橡诺城市云和大数据的整体发展战略，橡诺的智慧养老解决方案是以民政部《老年人社会福利机构基本规范》（MZ 008-2001）、国家质检总局《老年人、残疾人康复服务信息规范》（GB/T 24433-2009）、《养老机构基本规范》（GB/T 29353-2012）、卫计委《城乡居民健康档案基本数据集》（WS365-2011）、《居民健康档案的区域卫生信息平台技术规范》（WS/T 448-2014）等国家或行业标准为大数据标准化指南，结合各区域或城市政府智慧城市的具体特色，协调汇聚跨局委办的康养相关大数据基础，在此之上对接当地行业特色应用服务需求，通过橡诺城市康养云平台来提供标准化服务，为城市的养老产业发展上接政府政策导向、下连百姓需求提供“顶天立地”的桥梁和支撑作用。<br>
          具体解决方案划分为以下几个应用场景：社区养老、居家养老、机构养老、养老地产（养老社区）、康养大数据服务。<br><br>
          智慧社区养老<br>
          社区养老是以家庭养老为主，社区机构养老为辅，在为居家老人照料服务方面，又以上门服务为主，托老所服务为辅的整合社会各方力量的养老模式，具有可以借助政府街道社区土地建筑资源，便于引入社会资本的轻资产投资起步、成本低、定价灵活性高、见效快、服务种类丰富、服务可及性强等特点，是橡诺科技跟市、区政府合作，推动智慧养老产业发展的主要阵地，也是能较快实现养老商业运营的主推场景。
          对于新尝试养老PPP模式发展的政府、机构或社会资本，推荐以智慧社区养老作为试点切入。<br><br>
          智慧居家养老<br>
          根据中国式养老9073的国情，90%的老人选择居家养老，这也是政府倡导扶植的主要业务场景。鉴于目前国内的居家养老服务中普遍存在服务内容单一、工作人员流动性大、缺乏专业培训、只局限于大城市、市场机制不完善等问题，橡诺的居家养老解决方案采用立足智慧社区服务体系的建立，以街道、社区或乡镇为单位，以呼叫中心或社区养老机构+智能照护+社区服务的整合模式作为居家养老服务平台，用以确保提供给老人的各种智能养老设备的使用维护支持、上门家政、护理、康复医疗服务的及时性、高质量、稳定性和个性化定制需要。<br><br>
          智慧机构养老<br>
          机构养老市场，现在呈现面向高端消费群体的高档养老院和很大程度靠政府民政补贴运营的低端老人院、老人福利院、临终关怀医院等两级分化的特点。在这样的背景下，各地大多的养老机构都呈现服务内容单一、信息化智能化水平低、运营管理能力低下、难于规模化经营发展的特点。
          橡诺科技始终关注社会和行业痛点，急政府所急，想民众所想，致力于凭借多年积累的IT及互联网技术和行业经验，为努力提升服务能力的中低端养老机构提供标准的云养老解决方案。<br><br>
          智慧养老地产（养老园区）<br>
          结合智慧社区、智慧园区经验，橡诺科技提供包括园区物业、酒店、医院、养老园区监控、定位、一键呼叫、室内健康检测、急救协同、管家式服务等一系列完整的智慧养老地产（养老园区）解决方案，以满足致力于提供高端商业化养老服务的养老地产客户的需求。<br><br>
          智慧康养大数据<br>
          橡诺科技凭借多年在政务大数据、中小企业大数据等领域积累的行业大数据经验和洞察能力，紧跟国家养老、健康、医疗产业的信息标准化、服务标准化发展进程，正在加紧打造康养大数据标准和数据中心建设、大数据服务以及为政府提供决策支持的行业洞察服务能力。
          目前已初步建立了以老人及其家属的人口数据、健康档案、收入状况、土地、房产或房租、周边服务定价以及老人一般生活费等多指标要素，配以过程中老人和服务提供者产生的多维度信用记录构成的产业分析洞察模型。
        </div>
        <div class="title-sub">能力优势</div>
        <div class="text">
          全国广泛的城市政府合作关系<br>
          统一的城市级大数据和云平台解决方案<br>
          紧跟国家健康养老产业标准化发展的大数据战略<br>
          异构康养穿戴设备、监控设备的数据收集和接入能力<br>
          广泛的本地养老机构、社区服务提供商的合作体制<br>
          国内领先的养老大数据洞察分析、政府决策支持能力
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          政府：促进养老产业的智慧化升级、辅助行业信息及服务标准化发展和行业大数据积累、降低社会资本参与养老的门槛、为跨民政和卫计部门的资源协调提供平台、辅助决策、提供精准救助扶贫的数据依据等<br>
          养老机构：促进服务规范化、资源协调、商业盈利能力的提升<br>
          养老地产商：满足高端养老地产项目智能化解决方案的需要
        </div>
        <div class="title-sub">典型客户</div>
        <div class="text">
          城市政府（城市康养大数据中心建设、洞察分析和政策决策支持、城市养老产业升级等）<br>
          市区民政局、卫计委（智慧社区&居家养老试点、医养结合示范等）<br>
          养老机构（构建智慧运营管理平台、以信息系统带动机构服务水平规范化等）<br>
          养老地产商（智慧养老园区综合规划和建设等）<br>
          省市卫计委（面向老龄居民的分级诊疗、远程医疗、慢病管理等医养结合示范、老人康复医疗服务支持等）
        </div>
        <div class="title-sub">成功案例</div>
        <div class="text">
          澳门汇安通智能化长者关怀服务体系建设项目<br>
          联通集团公司“员工健康关怀”健康大数据项目<br>
          祥符club智慧社区养老开发项目
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        // width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>